import {
  FOLDER_ACCESS_MANAGER,
  FOLDER_ACCESS_RIGHTS,
  FOLDER_TYPES,
  FoldersV2,
} from 'lib/api/folders/getFoldersV2';
import { getSelectedFolder } from 'lib/components/dropdown/helpers/helpers';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

interface UseCurrentFolderParams {
  folders: FoldersV2[];
  userId: string;
}

interface UseCurrentFolderResult {
  currentFolder: FoldersV2;
  isLoading: boolean;
}

export function useCurrentFolder({
  folders,
  userId,
}: UseCurrentFolderParams): UseCurrentFolderResult {
  const location = useLocation();
  const queryParams: any = queryString.parse(location.search);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  // Initial folder state since we don't support null (workaround)
  const [currentFolder, setCurrentFolder] = useState<FoldersV2>({
    folderId: 'init',
    name: 'Init',
    userId: 0,
    sharedBy: undefined,
    isDefaultFolders: true,
    access: FOLDER_ACCESS_RIGHTS.EDIT,
    accessManager: FOLDER_ACCESS_MANAGER.SELF,
    isDeletable: false,
    folderType: FOLDER_TYPES.DEFAULT,
    folderSharedAs: undefined,
    isAIFolder: false,
  });

  useEffect(() => {
    if (!folders || folders.length === 0) {
      setIsLoading(false);
      return;
    }

    const selectedFolder = getSelectedFolder(
      queryParams.folderId,
      folders,
      userId,
      t
    );
    setCurrentFolder(selectedFolder);
    setIsLoading(false);
  }, [folders, queryParams.folderId]);

  return { currentFolder, isLoading };
}
